import axios from "axios";
import { Base_URL } from "../url";
import { toast } from "react-toastify";

export const getStoredUser = () => {
  try {
    const userStr = localStorage.getItem("userDetails");
    return userStr ? JSON.parse(userStr) : null;
  } catch (error) {
    console.error("Error parsing storedUser:", error);
    return null;
  }
};

export const getNotificationData = async () => {
  const storedUser = getStoredUser();
  const organisationId = storedUser?.organisationId;
  const url = `${Base_URL}/Notification/GetNotificationdata/${organisationId}`;

  const response = await axios.get(url);
  return response.data;
};

export const postNotificationData = async (notificationData) => {
  try {
    console.log("📤 Sending Notification Data Payload:");
    console.log(JSON.stringify(notificationData, null, 2));
    
    const response = await axios.post(
      `${Base_URL}/Notification/PostNotificationData`,
      notificationData,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    
    console.log("✅ Response from server:", response.data);
    
    // Log storage details
    if (response.data.StoredData) {
      console.log("💾 ID Storage Details:");
      console.log("- First TemplateId (int):", response.data.StoredData.TemplateId);
      console.log("- All TemplateIds (string):", response.data.StoredData.TemplateIds);
      console.log("- First DeliveryId (int):", response.data.StoredData.DeliveryId);
      console.log("- All DeliveryIds (string):", response.data.StoredData.DeliveryIds);
      console.log("- First RecipientId (int):", response.data.StoredData.RecipientId);
      console.log("- All RecipientIds (string):", response.data.StoredData.RecipientIds);
    }
    
    toast.success("✅ Notification scheduled successfully!");
    return response.data;
  } catch (error) {
    console.error("❌ Error posting Notification Data:", error);
    
    if (error.response) {
      console.error("Response error:", error.response.data);
      const errorMsg = error.response.data.message || error.response.data;
      toast.error(`❌ ${errorMsg}`);
    } else {
      toast.error("❌ Failed to schedule notification!");
    }
    
    throw error;
  }
};